<template>
<span v-if="content" v-html="content.replace(/(?:\r\n|\r|\n)/g, '<br />')"></span>
</template>

<script>
export default {
    name: 'RawContent',

    props: {
        content: {
            required: true,
            type: [String, undefined],
        }
    }
}
</script>